__turbopack_context__.v({
  "background": "DoubleBanner-module-scss-module__SJlE4W__background",
  "banner": "DoubleBanner-module-scss-module__SJlE4W__banner",
  "content": "DoubleBanner-module-scss-module__SJlE4W__content",
  "cta": "DoubleBanner-module-scss-module__SJlE4W__cta",
  "ctaIcon": "DoubleBanner-module-scss-module__SJlE4W__ctaIcon",
  "description": "DoubleBanner-module-scss-module__SJlE4W__description",
  "grid": "DoubleBanner-module-scss-module__SJlE4W__grid",
  "heading": "DoubleBanner-module-scss-module__SJlE4W__heading",
  "label": "DoubleBanner-module-scss-module__SJlE4W__label",
  "section": "DoubleBanner-module-scss-module__SJlE4W__section",
});
